<app-lot-connection-mode *ngIf="!readOnlyCatalog"></app-lot-connection-mode>

<div class="public-wrap">
  <div class="container">
    <div class="row">
      <div class="col-md-6 mb-2 mb-md-0 back-link-outer">
        <a class="back-link" role="button" (click)="goBack()">
          <img alt="back" src="../assets/images/back.svg" /> Back To All Lots</a>
      </div>
      <div class="col-md-6">
        <div class="next-prev-lots">
          <button type="button" class="btn btn-colored prev-btn-icon mr-2" role="button"
            (click)="goToLot(eachLotData?.previousLotNumber)" *ngIf="eachLotData?.previousLotNumber != null">
            <img alt="prev-icon" src="../assets/images/prev.svg" class="prev-icon mr-2" width="17" />
            Previous Lot
          </button>
          <button type="button" class="btn btn-colored next-btn-icon" role="button"
            (click)="goToLot(eachLotData?.nextLotNumber)" *ngIf="eachLotData?.nextLotNumber != null">
            Next Lot
            <img alt="next-arrow" src="../assets/images/next.svg" class="next-icon ml-2" width="17" />
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h1 class="view-lot-hdg">View Lot</h1>
      </div>

      <div class="col-12">
        <span class="card-badge min-width-auto badge-dark mb-2">Lot #{{ eachLotData?.lotNumber }}</span>
      </div>
      <div class="col-12">
        <p class="view-lot-author">
          Auction: {{ eachLotData?.auction?.title }}
        </p>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="view-lot-slider-wrapper">
      <div class="row">
        <div class="col-lg-6 view-left-wrapper">
          <div class="slide slide-view">
            <img alt="lot-images" src="/assets/images/image_not_found.svg"
              *ngIf="eachLotData?.thumbnailImages?.length == 0; else block" />
          </div>

          <ng-template #block>
            <ngx-slick-carousel class="carousel viewLotHeader" [config]="viewLotHeader">
              <div ngxSlickItem class="slide slide-view" *ngFor="let item of eachLotData?.images; let i = index">
                <img alt="lot-images" [src]="item?.name" />
              </div>
            </ngx-slick-carousel>

            <ngx-slick-carousel class="carousel viewLotThumbs m-0 custom-slick-arrow" [config]="viewLotThumbs">
              <div ngxSlickItem class="slide" *ngFor="let item of eachLotData?.thumbnailImages; let i = index">
                <!-- <a id="myLink" href="{{ item?.name }}" rel="prettyPhoto[pp_gal2]" class="prettyPhotoSlideWrapperLotDetail">
                  <img alt="auction-image" class="cursor-pointer preview-image" src="{{ item?.thumb }}" imgFallback="{{ item?.name }}"  />
                </a> -->
                <img alt="lot-images" [src]="item?.name" imagePreview [thumbnailImages]="eachLotData?.thumbnailImages"
                  [actualImages]="eachLotData?.images" [currentImage]="item" [header]="'Lot Images'" />
              </div>
            </ngx-slick-carousel>
          </ng-template>
        </div>

        <div class="col-lg-6 view-right-wrapper">
          <ng-container *ngIf="!readOnlyCatalog">
            <div class="closes-in-wrap" *ngIf="
                !eachLotData?.isBiddingPaused &&
                showTimer &&
                eachLotData?.loggedInUser &&
                eachLotData?.loggedInUser?.isApproved &&
                eachLotData?.auction.auctionStatus == auctionStatuses.live
              ">
              <img alt="clock" src="../assets/images/clock.svg" />
              <span class="closes-in">Closes In</span>
              <span class="close-time">
                <timer-countdown [timeLeft]="eachLotData?.timeLeft" [startTime]="eachLotData?.lotStartTimeUtc"
                  [endTime]="eachLotData?.lotEndTimeUtc" [isLowConnectionMode]="isLowConnectionMode"
                  (timeReached)="isTimeReached($event)"></timer-countdown>
                <span class="extended" *ngIf="eachLotData?.extendedByMinutes">Extended</span>
              </span>
            </div>
          </ng-container>

          <div class="view-lot-des2">
            <p>{{ eachLotData?.description }}</p>
          </div>

          <div class="view-lot-des2">
            <p>{{ eachLotData?.category }}</p>
          </div>

          <div class="location-wrap">
            <div class="location">
              <ng-container *ngIf="eachLotData?.quantity > 1">
                <span class="ml-0 mr-2 forQty">Qty: {{ eachLotData?.quantity }}</span>
              </ng-container>
              <img class="location mr-2" alt="location" src="/assets/images/location-grey.svg" />
              <span>{{ eachLotData?.location }}</span>
            </div>

            <ng-container *ngIf="!readOnlyCatalog">
              <ng-container *ngIf="
                  eachLotData?.auction?.auctionStatus == auctionStatuses.live
                ">
                <p class="bid">{{ eachLotData?.bidCount }} Bids</p>
              </ng-container>
            </ng-container>
          </div>

          <ng-container *ngIf="!readOnlyCatalog">
            <div class="view-lot-des2" style="font-size: 12px" *ngIf="
                showTimer &&
                eachLotData?.loggedInUser &&
                eachLotData?.auction.auctionStatus == auctionStatuses.live
              ">
              <ng-container *ngIf="eachLotData?.reservePrice">
                <ng-container *ngIf="eachLotData?.bidCount > 0; else elseTemplate">
                  <ng-container *ngIf="
                      eachLotData?.currentBid >= eachLotData?.reservePrice;
                      else elseBody
                    ">
                    <p>Reserve Price Met</p>
                  </ng-container>
                  <ng-template #elseBody>
                    <p>Reserve Price Not Met</p>
                  </ng-template>
                </ng-container>
                <ng-template #elseTemplate>
                  <p>Subject To Reserve Price</p>
                </ng-template>
              </ng-container>
              <!-- for bulk lot or individual lot i text -->
              <ng-container *ngIf="
                  eachLotData?.lotType === lotType.individual &&
                  eachLotData?.addedInBulkLotName
                ">
                <p class="m-0">
                  Subject to Bulk Lot of {{ eachLotData?.addedInBulkLotName }}
                  <span class="custom-tooltip" #tooltip="matTooltip" matTooltip="This lot is subject to Bulk Lot {{
                      eachLotData?.addedInBulkLotName
                    }}. In order for this lot to be awarded, the aggregate total of Lots {{
                      eachLotData?.associatedLots | bulkLots
                    }} must exceed the value of {{
                      eachLotData?.addedInBulkLotName
                    }}. Additionally, the Bulk Bidder/Individual Bidders will be given {{
                      eachLotData?.individualModifier
                    }}% protection." [matTooltipPosition]="'above'">
                    <img alt="info" src="../assets/images/info.svg" />
                  </span>
                </p>
              </ng-container>
              <ng-container *ngIf="
                  eachLotData?.lotType === lotType.bulk &&
                  eachLotData?.lots?.length
                ">
                <p class="m-0">
                  Subject to Lots {{ eachLotData?.lots | bulkLots }}
                  <span class="custom-tooltip" #tooltip="matTooltip"
                    matTooltip="
      The Bulk Bid is Subject to the Aggregate of Lots {{
                      eachLotData?.lots | bulkLots
                    }}. The Bulk Bidder/Piecemeal Bidders will be given {{
                      eachLotData?.modifier
                    }}% protection. Whichever lot(s) produce the highest total will be awarded the Lot. The Bulk Bid will close before the individual lots and you will not get a chance to re-bid after the individual lots close."
                    [matTooltipPosition]="'above'">
                    <img alt="info" src="../assets/images/info.svg" />
                  </span>
                </p>
              </ng-container>
              <ng-container *ngIf="!isLotClosed">
                <ng-container *ngIf="
                    eachLotData?.willSell &&
                    eachLotData?.lotType != eachLotData?.willSell &&
                    eachLotData?.addedInBulkLotName
                  ">
                  <p class="m-0">Below Bulk Bid Threshold</p>
                </ng-container>
                <ng-container *ngIf="
                    eachLotData?.willSell &&
                    eachLotData?.lotType != eachLotData?.willSell &&
                    eachLotData?.lots?.length
                  ">
                  <p class="m-0">Below Bulk Bid Threshold</p>
                </ng-container>
              </ng-container>
            </div>
            <ng-container *ngIf="
                !eachLotData?.isBiddingPaused &&
                eachLotData?.loggedInUser &&
                eachLotData?.loggedInUser?.isApproved &&
                eachLotData?.auction?.auctionStatus == auctionStatuses.live &&
                !isLotClosed
              ">
              <div class="top-price" *ngIf="loggedInUser">
                <div class="bid-price left-price">
                  <p class="name">{{eachLotData?.bidCount == 0 ? 'Opening Bid' : 'Current Bid'}} Amount</p>
                  <p class="amount">
                    {{
                    eachLotData?.currentBid
                    | auctionCurrency: eachLotData?.auction?.curreny
                    }}
                  </p>
                </div>

                <div class="bid-price right-price">
                  <p class="name">
                    {{
                    isUserHighestBidder
                    ? "Max Bid Amount"
                    : "Next Required Bid"
                    }}
                  </p>
                  <p class="amount">
                    <ng-container *ngIf="isUserHighestBidder; else nextRequiredBidSection">
                      {{
                      eachLotData?.highestBid
                      | auctionCurrency: eachLotData?.auction?.curreny
                      }}
                    </ng-container>
                    <ng-template #nextRequiredBidSection>
                      {{
                      eachLotData?.nextRequiredBid
                      | auctionCurrency: eachLotData?.auction?.curreny
                      }}
                      <small>
                        {{ eachLotData?.quantity > 1 ? "Each" : "" }}
                      </small>
                    </ng-template>
                  </p>
                </div>
              </div>
              <div class="bid-price-input" *ngIf="loggedInUser">
                <div class="price-left">
                  <div class="form-group no-float-fields m-0 height-42">
                    <mat-form-field appearance="outline">
                      <input matInput type="number" [formControl]="biddingAmount" />
                    </mat-form-field>
                    <control-messages [control]="biddingAmount"></control-messages>
                  </div>
                </div>

                <div class="price-right mt-2">
                  <button type="button" class="btn btn-white-border w-100" role="button" (click)="onSubmit(false)">
                    Bid Now
                  </button>
                </div>
              </div>
              <div class="bid-submit mt-2" *ngIf="loggedInUser && !isUserHighestBidder">
                <button type="button" class="btn btn-colored w-100" role="button" (click)="onSubmit(true)">
                  Quick Bid
                  {{
                  eachLotData?.nextRequiredBid
                  | auctionCurrency: eachLotData?.auction?.curreny
                  }}
                </button>
              </div>

              <div class="bid-green-hover-outer mt-2" *ngIf="loggedInUser && isUserHighestBidder">
                <button type="button" class="btn btn-colored btn-green-hover w-100">
                  <img alt="high bidder" class="mr-2" src="./assets/images/white-check.svg" />
                  High Bidder
                </button>
                <div class="hover-wrap">
                  <p class="m-0">
                    You will be able to "Quick Bid" after your bid is outbid.
                    <br />
                    <br />
                    You may still increase your max bid by entering a higher
                    value on clicking Bid Now.
                  </p>
                </div>
              </div>

              <div *ngIf="errorMsg != null">
                <p class="error-msg">{{ errorMsg }}</p>
              </div>
            </ng-container>

            <div class="pause-bidding text-center my-3" *ngIf="eachLotData?.isBiddingPaused">
              <img alt="clock-icon" class="clock-icon" style="height: 25px" src="./assets/images/clock-grey.svg" />
              <h4>Bidding is paused!</h4>
            </div>

            <div class="auc-card-content auc-card-btns pt-3 text-center">
              <button type="button" class="btn btn-white-border w-100" *ngIf="
                  auctionDetail?.saleType?.registrationFormat == 1 &&
                  auctionDetail?.isRegistrationActive &&
                  (auctionDetail?.auctionStatus == 1 ||
                    auctionDetail?.auctionStatus == 2) &&
                  eachLotData?.loggedInUser == null &&
                  showTimer
                " role="button" (click)="goToRegister(auctionDetail?.auctionCode)">
                Register to Bid
              </button>

              <div class="w-100 mb-2 sold-wrap text-center" *ngIf="
                  eachLotData?.lotStatus &&
                  isLotClosed &&
                  eachLotData?.loggedInUser
                ">
                <ng-container [ngSwitch]="eachLotData?.lotStatus">
                  <ng-container *ngSwitchCase="soldStatuses.sold">
                    <div class="badge-type">
                      <span class="card-badge-colored mr-2">SOLD</span>
                    </div>
                    <p *ngIf="eachLotData?.soldTo == loggedInUser">
                      Winning Bidder
                    </p>
                    <p *ngIf="findLooser() > -1  && eachLotData?.soldTo !== loggedInUser">Unsuccessful</p>
                  </ng-container>
                  <ng-container *ngSwitchCase="soldStatuses.unsold">
                    <div class="badge-type">
                      <span class="card-badge-colored mr-2"> UNSOLD </span>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="soldStatuses.cancelled">
                    <div class="badge-type">
                      <span class="card-badge-colored mr-2"> CANCELLED </span>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="soldStatuses.pending">
                    <div class="badge-type">
                      <span class="card-badge-colored mr-2"> PENDING </span>
                    </div>
                  </ng-container>
                </ng-container>
              </div>

              <ng-container *ngIf="false">
                {{ "this is not used now" }}
                <div class="w-100 mb-2 sold-wrap text-center" *ngIf="
                    !eachLotData?.lotStatus &&
                    isLotClosed &&
                    eachLotData.loggedInUser
                  ">
                  <div class="badge-type">
                    <ng-container [ngSwitch]="eachLotData?.lotStatus">
                      <div *ngSwitchCase="3">
                        <span class="card-badge-colored mr-2"> UNSOLD </span>
                      </div>
                      <div *ngSwitchCase="4">
                        <span class="card-badge-colored mr-2"> CANCELLED </span>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="!isLotClosed">
                <div class="starred add-wishlist mt-2" role="button" (click)="addToWatchList()"
                  *ngIf="loggedInUser != 0 && !isAddedToWatchlist">
                  <span class="for-image">
                    <img alt="not added" src="/assets/images/star-stroke-grey.svg" />
                  </span>
                  <span class="ml-2">Add To Watchlist</span>
                </div>

                <a [routerLink]="['/profile/my-watchlist']" *ngIf="loggedInUser != 0 && isAddedToWatchlist">
                  <div class="add-wishlist mt-2 d-inline-flex">
                    <span class="for-image">
                      <img alt="added" src="/assets/images/star-filled.svg" />
                    </span>
                    <span class="ml-2">Go to Watchlist</span>

                  </div>

                </a>
                <span class="outbid-text ml-2" *ngIf="eachLotData?.outbid">Outbid</span>
              </ng-container>

              <ng-container *ngIf="isLowConnectionMode && !isLotClosed">
                <a class="iconRefresh" role="button" role="button" (click)="getViewLotDetail()">
                  <img alt="refresh" class="mr-2" title="refresh" src="/assets/images/refresh.svg" />
                  Refresh
                </a>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #quickBidModal>
  <div class="modal-header pl-3">
    <h4 class="modal-title pull-left">Review Bids</h4>
    <button type="button" class="close pull-right circle-icon" aria-label="Close" role="button"
      (click)="closeReviewModal()">
      <img alt="cross" _ngcontent-lrm-c188="" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <div class="column-list">
      <div class="parts">
        <div class="left-wrap">Auction</div>
        <div class="right-wrap">{{ eachLotData.auction.title | titlecase }}</div>
      </div>

      <div class="parts">
        <div class="left-wrap">Bidder</div>
        <div class="right-wrap">
          Paddle No. {{ eachLotData.loggedInUser.paddleNumber }} {{userFullName | titlecase}}
        </div>
      </div>
    </div>

    <div class="data-table-wrap w-100">
      <table aria-label="table" class="w-100 table-with-border review-bids-table">
        <tbody>
          <tr class="mat-row">
            <td class="mat-cell column-1 listing-data-entry table-with-row-header">
              <span class="td-header">Lot #</span>
              {{ eachLotData.lotNumber }}
            </td>
            <td class="mat-cell column-2 listing-data-entry table-with-row-header yellow-bg">
              <span class="td-header">Lot Description</span>
              {{ eachLotData.description | characterLimit: 50 }}
            </td>
            <td class="mat-cell column-3 listing-data-entry table-with-row-header" *ngIf="!isQuickBidOrNot">
              <span class="td-header">Current</span>
              {{ eachLotData.currentBid | auctionCurrency: eachLotData.auction.curreny }}
            </td>
            <td class="mat-cell column-3 listing-data-entry table-with-row-header" *ngIf="!isQuickBidOrNot">
              <span class="td-header">New Bid</span>
              {{ biddingAmount.value | auctionCurrency: eachLotData.auction.curreny }}


            </td>
            <td class="mat-cell column-3 listing-data-entry table-with-row-header" *ngIf="isQuickBidOrNot">
              <span class="td-header">Quick Bid</span>
              {{ eachLotData.nextRequiredBid | auctionCurrency: eachLotData.auction.curreny }}
            </td>
          </tr>
          <ng-container *ngIf="!isQuickBidOrNot">
            <div class="reviewBidError" *ngIf="biddingAmount?.value < eachLotData.nextRequiredBid">
              <img alt="invalid bid" class="mr-2" src="assets/images/bidError.svg" />
              <p>
                <strong>Invalid Bid:</strong> Bid of
                {{ biddingAmount?.value | auctionCurrency: eachLotData.auction.curreny }}
                is lower than next required bid of
                {{
                eachLotData.nextRequiredBid
                | auctionCurrency: eachLotData.auction.curreny
                }}
              </p>
            </div>
          </ng-container>
        </tbody>
      </table>
    </div>

    <ng-container *ngIf="changeInAmount">
      <p>Note : New Bid has been placed. Please bid again.</p>
    </ng-container>

    <div class="review-btns-wrap mt-3">
      <ng-container *ngIf="!changeInAmount">
        <button type="button" class="btn btn-colored" role="button" (click)="submitBidByApi(isQuickBidOrNot)">
          Submit Bid
        </button>
      </ng-container>
      <button type="button" class="btn btn-white-border" role="button" (click)="closeReviewModal()">
        Cancel
      </button>
    </div>
  </div>
</ng-template>
